// GES-405 PDF UX — "Save PDF": the server-rendered PDF (ticketed + sanitised, see api.renderPdf). Shared by DocumentSheet and the Monthly Report.
// If the browser's PDF viewer is enabled the PDF opens inline in a tab pre-opened inside the click (popup-safe); if the user set
// "Download PDF files" (navigator.pdfViewerEnabled === false) or the popup is blocked, it is saved as a named file. Rejects on failure so
// the caller can tell the user / fall back; it never prints.
import api from '../../services/api';

const safeName = (s) => String(s || 'document').replace(/[^A-Za-z0-9._-]+/g, '_').slice(0, 80) || 'document';

export function saveBlob(blob, filename) {
  const url = URL.createObjectURL(blob); const a = document.createElement('a');
  a.href = url; a.download = `${safeName(filename)}.pdf`; a.style.display = 'none'; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

// Call synchronously from the click handler.
export function savePdf(req, filename) {
  const inline = typeof navigator === 'undefined' || navigator.pdfViewerEnabled !== false;
  const pop = inline ? window.open('', '_blank') : null;
  return api.renderPdf({ ...req, filename: safeName(filename) }).then((blob) => {
    if (pop && !pop.closed) { pop.location.href = URL.createObjectURL(blob); return 'inline'; }
    saveBlob(blob, filename); return 'download';
  }).catch((e) => { if (pop) pop.close(); throw e; });
}
